import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { AppTheme, AppStyles } from '../styles/AppTheme';
import { ButtonComponent } from '../components/quizzing/ButtonComponent';
import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import { Controller } from '../common/Controller';
import { AppHelper } from '../helpers/AppHelper';

export class Home extends Component {
  constructor(props) {
    super(props);
  }

  getHomeLink = () => {
    if (Controller.get().loginMgr().getCurrentUser()) {
      return ({
        pathname: AppConfig.clientDashboard,
      })
    } else {
      return ({
        pathname: '/login',
        search: (this.props.location && this.props.location.search) ? this.props.location.search : ''
      })
    }
  }

  render() {
    return (
      <div className={css(AppStyles.containerNarrow)}>
        <div className={css(Styles.outerContainer)}>
          <div className={css(Styles.imgContainer)}>
            <img
              src={require('../assets/images/homeImg.png')}
              className={css(Styles.imgContent)}
            />
          </div>
          <h1 className={css(Styles.homeMainHeader)}>{AppConfig.Title}</h1>
          <h2 className={css(Styles.homeL2Header)}>Charting the Menstrualome</h2>
          <h2 className={css(Styles.homeL3Header)}>NextGen Jane</h2>
          <Link to={{
            pathname: '/introduction',
            search: (this.props.location && this.props.location.search) ? this.props.location.search : ''
          }}
          className={css(CommonStyles.link)}>
            <ButtonComponent
              label='INTRODUCTION'
            />
          </Link>
          <Link to={this.getHomeLink()}
            className={css(CommonStyles.link)}>
            <ButtonComponent
              label='GET STARTED'
            />
          </Link>
          {AppHelper.getCopyrightString()}
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  containerNarrow: {
    height: 'unset'
  },
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0px 10px',
    marginBottom: 30,
    marginTop: 10
  },
  imgContainer: {
    maxWidth: 800,
    '@media (max-width: 767px)': {
      minWidth: 'unset',
      width: '100%',
    }
  },
  imgContent: {
    width: '100%',
    height: '100%',
  },
  homeMainHeader: {
    fontSize: 48,
    margin: AppTheme.pMargin,
    fontWeight: 'normal',
    textAlign: 'center',
    '@media (max-width: 767px)': {
      fontSize: 30,
    }
  },
  homeL2Header: {
    fontSize: 24,
    fontWeight: 'normal',
    margin: AppTheme.pMargin,
    marginTop: 15,
    marginBottom: 5,
    textAlign: 'center',
    '@media (max-width: 767px)': {
      fontSize: 20,
    }
  },
  homeL3Header: {
    fontSize: 16,
    fontWeight: 'normal',
    margin: AppTheme.pMargin,
    marginTop: 15,
    marginBottom: 5,
    '@media (max-width: 767px)': {
      fontSize: 14,
    }
  }
})



// WEBPACK FOOTER //
// ./src/screens/Home.js